import { B2bSavingPlanCategory, B2bSavingPlanType } from '@Common/types/b2b/plans';
import { B2bManagedPlanRebalancingFrequency, B2bPlanFeePaidBy } from '@Common/types/bo/b2b/plans';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const planTypeChoices = makeChoicesCommon<B2bSavingPlanType | B2bSavingPlanCategory>()({
  PEI: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEI',
  PEI_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEI_LIBRE',
  PEI_PROFILE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEI_PROFILE',
  PEE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEE',
  PEE_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEE_LIBRE',
  PEE_PROFILE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEE_PROFILE',
  PEEG: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEEG',
  PEEG_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEEG_LIBRE',
  PEEG_PROFILE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PEEG_PROFILE',
  PERECOI_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOI_LIBRE',
  PERECOI_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOI_PILOTE',
  PERECOI: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOI',
  PERECO_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECO_LIBRE',
  PERECO_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECO_PILOTE',
  PERECO: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECO',
  PERECOG_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOG_LIBRE',
  PERECOG_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOG_PILOTE',
  PERECOG: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOG',
  PERCOI: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCOI',
  PERCOI_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCOI_LIBRE',
  PERCOI_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCOI_PILOTE',
  PERCO: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCO',
  PERCO_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCO_LIBRE',
  PERCO_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERCO_PILOTE',
  PERO_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERO_LIBRE',
  PERO_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERO_PILOTE',
  PERO: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERO',
  PERU_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERU_LIBRE',
  PERU_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERU_PILOTE',
  PERU: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERU',
  PER_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PER_LIBRE',
  PER_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PER_PILOTE',
  PER: 'resources.bo_common.b2b.companies.saving_plans.types_short.PER',
  ARTICLE_82_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_82_LIBRE',
  ARTICLE_82_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_82_PILOTE',
  ARTICLE_82: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_82',
  ARTICLE_83_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_83_LIBRE',
  ARTICLE_83_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_83_PILOTE',
  ARTICLE_83: 'resources.bo_common.b2b.companies.saving_plans.types_short.ARTICLE_83',
  PERECOER_LIBRE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOER_LIBRE',
  PERECOER_PILOTE: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOER_PILOTE',
  PERECOER: 'resources.bo_common.b2b.companies.saving_plans.types_short.PERECOER',
  ER_EXTERNAL: 'resources.bo_common.b2b.companies.saving_plans.types_short.ER_EXTERNAL',
});

export const feePaidByChoices = makeChoicesCommon<B2bPlanFeePaidBy>()({
  company: 'resources.bo_common.b2b.companies.saving_plans.management_fee_paid_by.company',
  employee: 'resources.bo_common.b2b.companies.saving_plans.management_fee_paid_by.employee',
});

export const planCategoryChoices = makeChoicesCommon<B2bSavingPlanCategory>()({
  PEI: 'resources.bo_common.b2b.companies.saving_plans.types.PEI',
  PEE: 'resources.bo_common.b2b.companies.saving_plans.types.PEE',
  PEEG: 'resources.bo_common.b2b.companies.saving_plans.types.PEEG',
  PERECOI: 'resources.bo_common.b2b.companies.saving_plans.types.PERECOI',
  PERECO: 'resources.bo_common.b2b.companies.saving_plans.types.PERECO',
  PERECOG: 'resources.bo_common.b2b.companies.saving_plans.types.PERECOG',
  PERCOI: 'resources.bo_common.b2b.companies.saving_plans.types.PERCOI',
  PERCO: 'resources.bo_common.b2b.companies.saving_plans.types.PERCO',
  PERO: 'resources.bo_common.b2b.companies.saving_plans.types.PERO',
  PERU: 'resources.bo_common.b2b.companies.saving_plans.types.PERU',
  PER: 'resources.bo_common.b2b.companies.saving_plans.types.PER',
  ARTICLE_82: 'resources.bo_common.b2b.companies.saving_plans.types.ARTICLE_82',
  ARTICLE_83: 'resources.bo_common.b2b.companies.saving_plans.types.ARTICLE_83',
  PERECOER: 'resources.bo_common.b2b.companies.saving_plans.types.PERECOER',
  ER_EXTERNAL: 'resources.bo_common.b2b.companies.saving_plans.types_short.ER_EXTERNAL',
});

export const managedPlanRebalancingFrequencyChoices =
  makeChoicesCommon<B2bManagedPlanRebalancingFrequency>()({
    '1_month':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.1_month',
    '2_months':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.2_months',
    '3_months':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.3_months',
    '4_months':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.4_months',
    '6_months':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.6_months',
    '12_months':
      'resources.bo_common.b2b.companies.saving_plans.rebalancing_frequency.values.12_months',
  });
